// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { deletePreprocessedRecords } from 'services/MasspayoutService'
import { logSentryError } from 'utils/sentry'

export const useDeletePreProcessedRecordMutation = () => {
  return useMutation({
    mutationFn: deletePreprocessedRecords,
    onError(error: { status: number; message?: string; errorList: unknown }, data) {
      logSentryError('Error from useDeletePreProcessedRecordMutation', error, data)
    },
  })
}
